import { configureStore } from '@reduxjs/toolkit'
import { orderDialogReducers } from './orderDialog/orderDialogSlice'

export const sunovationStore = configureStore({
  reducer: {
    orderDialog: orderDialogReducers,
  },
})

export type TypedSunovationDispatch = typeof sunovationStore.dispatch
export type TypedSunovationState = ReturnType<typeof sunovationStore.getState>
